export default "__VITE_ASSET__DIjxDqkI__"